var mentions_default = {
  "mention": "_3waYY",
  "mentionViewer": "ab4kU",
  "cursorDefault": "pIfAE",
  "cursorPointer": "zOA5k"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
